import React from "react";
import { LogsIcon } from "./BackendLogsPanel";

const LogoutIcon = () => (
  <svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const SIDEBAR_WIDTH = 56;

const Sidebar = ({ onLogout, onToggleLogs, onLogsIconInteract }) => {
  const sidebarStyle = {
    position: "fixed",
    left: 0,
    top: 0,
    width: SIDEBAR_WIDTH,
    height: "100vh",
    maxHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#1c2b41",
    zIndex: 1000,
  };

  const logoStyle = {
    marginBottom: "8px",
    marginTop: "28px",
    width: "32px",
    height: "32px",
    objectFit: "contain",
  };

  const bottomStyle = {
    marginTop: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  const logoutButtonStyle = {
    marginBottom: "40px",
    cursor: "pointer",
    padding: "8px",
    color: "#ffffff",
    border: "none",
    background: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s",
    borderRadius: "8px",
  };

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("authority");
    onLogout();
  };

  const handleLogsIconInteraction = () => {
    if (onLogsIconInteract) onLogsIconInteract();
  };

  return (
    <div style={sidebarStyle}>
      <img
        src="/logo.png"
        alt="Logo"
        style={logoStyle}
      />

      <div style={bottomStyle}>
        <button
          type="button"
          style={logoutButtonStyle}
          onClick={(e) => {
            onToggleLogs();
            handleLogsIconInteraction();
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#253b5c";
            handleLogsIconInteraction();
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
          }}
          title="Admin Backend Logs"
          aria-label="Admin Backend Logs"
        >
          <LogsIcon />
        </button>
        <button
          type="button"
          style={logoutButtonStyle}
          onClick={handleLogout}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#253b5c";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
          }}
          title="Log out"
          aria-label="Log out"
        >
          <LogoutIcon />
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
export { SIDEBAR_WIDTH };
